import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { AdminDriverRegistrationService } from "../service";
import { IDriverRegistration } from "../interface";
import CreateForm from "./CreateForm";
import { IBrand } from "../../brand/interface";
import { AdminBrandService } from "../../brand/service";

const UpdateDriver = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [state, setState] = useState<IDriverRegistration | null>(null);
    const [brands, setBrands] = useState<IBrand[]>([]);

    useEffect(() => {
        AdminBrandService.getAll({ page: 1, perPage: 0 })
            .then((response) => {
                const { data } = response;
                setBrands(data?.items ?? []);
            })
            .catch(ErrorToast);
    }, []);

    useEffect(() => {
        if (id) {
            AdminDriverRegistrationService.getSingle(Number(id))
                .then((response) => {
                    const { data } = response;
                    const normalizedData = {
                        ...data,
                        brands: (data.brands || []).map((brand: any) => brand.id ?? brand),
                        active: !!data.active,
                        prizeDraws: !!data.prizeDraws,
                        emailInfo: !!data.emailInfo,
                        residesInAustria: !!data.residesInAustria,
                        residesOutsideAustria: !!data.residesOutsideAustria,
                        classBLicense2Years: !!data.classBLicense2Years,
                    };

                    setState(normalizedData);
                })
                .catch(ErrorToast);
        }
    }, [id]);

    const submitHandler = () => {
        if (!state?.id) return;

        AdminDriverRegistrationService.update(
            {
                ...state,
                brands: state.brands || [],
                active: !!state.active,
                prizeDraws: !!state.prizeDraws,
                emailInfo: !!state.emailInfo,
                residesInAustria: !!state.residesInAustria,
                residesOutsideAustria: !!state.residesOutsideAustria,
                classBLicense2Years: !!state.classBLicense2Years,
            },
            state.id
        )
            .then(() => {
                SuccessToast(t("driver_registration.successfully_updated"));
                navigate(-1);
                setState(null);
            })
            .catch(ErrorToast);
    };

    return (
        <div className="col-12">
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitHandler();
                }}
            >
                <CreateForm state={state} setState={setState} brands={brands} />
            </Form>
        </div>
    );
};

export default UpdateDriver;
